import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { DashboardScreenComponent } from "./dashboard-screen/dashboard-screen.component";

const routes: Routes = [
  {
    path: "dashboard",
    component: DashboardScreenComponent,
    canActivate: [AuthGuard],
  },
];

export const DashboardRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/dashboard/dashboard.routes.ts